import {z} from 'zod';

import {configuratorFormSchema} from './configuratorFormSchema';

const uuid = z.string().uuid();
const partialSelectionId = uuid.or(z.literal(''));

export const configuratorDraftSchema = configuratorFormSchema.extend({
  modelYearId: partialSelectionId,
  trimId: partialSelectionId,
  variantId: partialSelectionId,
  colourId: partialSelectionId,
  upholsteryId: partialSelectionId,
  label: z.string(),
});
